import React, { useCallback } from 'react'
import OderInfo from './indexthree'
import { Modal, Toast } from 'antd-mobile'
import style from './oderInfothree.module.css'
import { useEffect, useState, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import Login from '../Login'
import { goodsauthtwo } from '../../utils/tooltwo'
import Detainment from '../Detainment/indextow'
import { PAY } from '../../utils/config'

export default function Mypopup(poprs) {
  let history = useLocation()
  const [countDown, setCountDown] = useState(1800)
  let [checked, setChecked] = useState(false) // 协议选择
  let [key, setKey] = useState(undefined) // 用户key
  let [member_id, setMember_id] = useState(undefined) // 用户id
  let [phoneNum, setPhoneNum] = useState(false) //是否登录过
  let [userPhone, setUserPhone] = useState(() =>poprs.phoneData) //用户手机号
  let [goodsPrice, setGoodsPrice] = useState('')
  const [checkedPay, setCheckedPay] = useState(() => PAY.WX) // 支付选择
  const [modal2, setModal2] = useState(false)
  const [subFlag, setSubFlag] = useState(false)
  let [phoneNums, setPhoneNums] = useState('')
  let [pri, setPri] = useState('') //用户手机号


  // console.log(poprs.phoneData,'手机号');
  /**
   * 判断是否登录过，没登录获取用户信息，登录过直接调取支付
   */
  function getPhone() {
    return sessionStorage.getItem('member_id') ? true : false
  }
  // 存储用户信息
  function storagUsertUserInfo(info) {
    sessionStorage.setItem(info.name, info.value)
  }
  // 获取用户信息
  function getUserInfo(name) {
    return sessionStorage.getItem(name) || localStorage.getItem(name)
  }

  // 获取用户手机号
  useEffect(() => {
    console.log('已经加载手机号了');
    if (sessionStorage.getItem('member_id') || localStorage.getItem('member_id')) {
      let getPhone = sessionStorage.getItem('phone') || localStorage.getItem('phone');
      let hidPhone = getPhone.substring(getPhone.length - 11, getPhone.length - 8) + '****' + getPhone.substring(getPhone.length - 4);
      setUserPhone(hidPhone);
    }
  }, [setUserPhone])

  //显示手机号
  useEffect(() => {
    setInterval(() => {
      let phoneData = localStorage.getItem('phone')
      if(phoneData !== null && phoneData !== ''){
        let phoneDatas = phoneData.substring(getPhone.length - 11, phoneData.length - 8) + '****' + phoneData.substring(phoneData.length - 4);
        setPhoneNums(phoneDatas)
      }
    }, 500);
  })

  useEffect(() => {
    setGoodsPrice(() => (poprs.sku_id == 1 ? '8.8' : '8.8'))
  }, [poprs.sku_id, goodsPrice])
  useEffect(() => {
    if(poprs.pri == 'undefined' || poprs.pri == ''){
      setPri('8.8')
    }else{
      setPri((poprs.pri/100))
    }
  }, [])
  useEffect(() => {
    let timer = null
    // 倒计时
    timer = setInterval(() => {
      setCountDown((countDown) => {
        return --countDown
      })
    }, 1000)
    return () => {
      clearInterval(timer)
    }
  }, [])
  useEffect(() => {
    let pathSearch = history.search.substring(1)
    pathSearch = pathSearch.split('=')
    if (pathSearch[0] === 'checked' && pathSearch[1] === 'true') {
      setChecked(pathSearch[1])
    }
  }, [setChecked, history.search])
  // 子组件方法
  const childRef = useRef()
  const loginRef = useRef()
  // const refLogin = useRef()
  // 登录或者支付
  const handleFun = () => {
    // window.gdt('track', 'RESERVATION', { key1: 'value1', key2: 'value2' })
    payed()
  }
  // 挽留页弹框
  const leave = () => {
    setModal2(false)
    poprs.onClose()
  }
  const payClose = () => {
    setModal2(true)
  }
  // 关闭
  const closePopup = () => {
    setModal2(true)

  }

  const payed = useCallback((num) => {
    let userMember = sessionStorage.getItem('member_id') || localStorage.getItem('member_id')
    goodsauthtwo(userMember).then((res) => {
      // res.code = -1 // 临时
      if (res.code == -110022 && !num) {
        // 支付
        console.log('未购买')
        // childRef.current.serverToken()
        // childRef.current.setGoods()
        childRef.current.payFun()
      }
      if (res.code === 1) {
        let memberId =
          sessionStorage.getItem('member_id') ||
          localStorage.getItem('member_id')
        window.location.hash = '#/result?member_id=' + memberId
      }
    })
  }, [])
  const enter = () => {
    setModal2(false)
  }
  useEffect(() => {
    if (getPhone()) {
      payed(1)
    }
  }, [payed])

  const changeVisible = (val) => {
    leave()
  }

  const changeSubFlag = (val) => {
    setSubFlag(val)
  }

  return (
    <Modal
      animationType
      visible={poprs.visible}
      onClose={() => closePopup()}
      animationType="slide-up"
      // afterClose={() => poprs.afterClose()}
      closable={true}
    >
      <div className={style.Fclose} onClick={() => { payClose() }}>
        ×
      </div>

      <div className={style.Fbanner}>
        订单已提交成功，请尽快完成支付！
      </div>
      <div className={style.Fprice}>
        <div>
          <p>应付金额</p>
          <p className={style.money}>￥{pri}</p>
        </div>
      </div>

      <div className={style.Fdata}>
        <div className={style.Fline}>
          商品名称
          <span>证券学院.小牛特训营</span>
        </div>
        <div className={style.Fline}>
          手机号
          <span>{phoneNums}</span>
        </div>
      </div>

      <OderInfo
        changeVisible={(val) => changeVisible(val)}
        cRef={childRef}
        member_id={member_id || getUserInfo('member_id')}
        key={key || getUserInfo('key')}
        checked={checked}
        checkedPay={checkedPay}
        checkeFun={(val) => setCheckedPay(val)}
        sku_id={poprs.sku_id}
      />
      <div className={style.bottomBnts}>
        <button
          // disabled={!subFlag}
          className={style.payBtns}
          style={{ backgroundColor: '#2064CA' }}
          onClick={() => {
            handleFun()
          }}
        >
          确认支付
        </button>
      </div>
      <Detainment
        onClose={() => setModal2(false)}
        visible={modal2}
        leave={() => leave()}
        enter={enter}
        sku_id={poprs.sku_id}
      />
    </Modal>
  )
}
